const Footer = ({ darkMode }) => {
  const currentYear = new Date().getFullYear();
  return (
    <footer
      className={`py-3 ${
        darkMode ? "bg-dark text-white" : "bg-light text-dark"
      }`}
    >
      <div className="container text-center">
        <p>
          © {currentYear} door Joppe Dierckx
        </p>
      </div>
    </footer>
  );
};

export default Footer;
